import { css } from 'lit'
import { html, unsafeStatic } from 'lit/static-html.js'
import HHQuizElement from '../element.js'
import './navigation.js'

/**
 * Quiz's header
 * - Back button
 * - Logo
 * - Close button
 * @extends
 */

class HHQuizHeader extends HHQuizElement {
  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return html`<div class="hh-quiz-header">
        ${!this.store.isStatic ? html`<hh-quiz-router-link to="${this.router.previousPath}" @click="${() => this.router.previousPath ? null : this.store.openModal('close-warning')}">
          <span class='hh-quiz-header__back'>
            ${unsafeStatic(HH_QUIZ['icons'].caret)}
            <span class='hh-quiz-header__back__label utility'>${HH_QUIZ.t.actions.back}</span></span
          >
        </hh-quiz-router-link>`: html`<div class="hh-quiz-header__back"></div>`}
        <a @keydown="${(ev) => ev.stopPropagation()}" class='block hh-quiz-header__logo' href='${window.HH_QUIZ.routes.root_url}' aria-label='${window.HH_QUIZ.shop.name}'>
          ${unsafeStatic(HH_QUIZ['icons'].logo)}
          </a>
        <button
          class="hh-quiz-header__close utility"
          @keydown="${(ev) => ev.stopPropagation()}"
          @click="${() => this.store.openModal('close-warning')}"
        >
        <span class='hh-quiz-header__close'>
          ${this.store.isStatic ? '' : html`<span class='hh-quiz-header__close__label utility'>${HH_QUIZ.t.actions.exit_quiz}</span>`}
          <span>
            ${unsafeStatic(HH_QUIZ['icons'].close)}
          </span>
        </span>
        </button>
      </div>
      ${this.router.current?.hideNavigation
        ? ''
        : html`<hh-quiz-navigation></hh-quiz-navigation>`}`
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 60px;
        padding: 0 30px;
        color: var(--hh-color-aged-black);
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-header {
          padding: 0 20px;
        }
      }

      .hh-quiz-header__logo {
        align-items: center;
        display: flex;
        justify-content: center;
        align-self: center;
        color: var(--hh-color-aged-black);
      }

      .hh-quiz-header__logo svg {
        width: 100%;
        max-width: max(8vw, 122px);
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-header__logo svg {
          max-width: 89px;
        }
      }

      .hh-quiz-header__close {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
      }

      .hh-quiz-header__close,
      .hh-quiz-header__back {
        display: flex;
        width: max(7vw, 102px);
        height: 25px;
        align-items: center;
        text-decoration: none !important;
        color: var(--hh-color-aged-black);
      }

      .hh-quiz-header__close__label,
      .hh-quiz-header__back__label {
        text-decoration: none !important;
        text-decoration-style: none !important;
        padding-top: 1.5px;
      }

      .hh-quiz-header__close svg,
      .hh-quiz-header__back svg {
        display: block;
      }

      .hh-quiz-header__back {
        justify-content: flex-start;
      }

      .hh-quiz-header__back svg {
        transform: rotate(90deg);
        margin-right: 13px;
        width: 12px;
        height: auto;
      }

      .hh-quiz-header__close {
        justify-content: flex-end;
      }

      .hh-quiz-header__close svg {
        width: 12px;
        height: 12px;
        margin-left: 16px;
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-header__close,
        .hh-quiz-header__back {
          width: 42px;
        }
        .hh-quiz-header__close__label {
          display: none;
        }
        .hh-quiz-header__back svg {
          margin-right: 4px;
        }
      }

      hh-quiz-router-link.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    `,
  ]
}

customElements.define('hh-quiz-header', HHQuizHeader)
